// TIDAK TERPAKAI — komponen pendukung V1: hanya dipakai oleh halaman V1 (frontend/src/pages/) dan/atau AppShell.jsx (V1), yang keduanya tidak terjangkau sejak App.js mengarahkan semua rute ke V2App. Jangan diedit. Lihat memory/DEPRECATED.md.
// =============================================================================
// FILE STATUS HEADER  (lihat /app/memory/MASTER_BLUEPRINT.md A7)
// status   : ACTIVE
// version  : 1.0
// updated  : 2026-06-15
// replaces : -
// protected: NO  -> Tambahkan riwayat di /app/memory CHANGELOG saat diubah.
// =============================================================================

import React from "react";
import { Card } from "@/components/ui/card";

export const KpiCard = ({ icon: Icon, label, value, sub, accent, testid }) => {
  return (
    <Card className="p-4 sm:p-5 rounded-2xl kpi-shadow border-border" data-testid={testid}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs font-medium text-muted-foreground truncate">{label}</p>
          <p className="text-2xl sm:text-3xl font-semibold tracking-tight font-display mt-1 truncate">{value}</p>
          {sub && <p className="text-xs text-muted-foreground mt-1 truncate">{sub}</p>}
        </div>
        {Icon && (
          <div className={`w-10 h-10 shrink-0 rounded-xl flex items-center justify-center ${accent ? "bg-[hsl(var(--accent))]/15 text-[hsl(var(--accent))]" : "bg-primary/10 text-primary"}`}>
            <Icon className="w-5 h-5" />
          </div>
        )}
      </div>
    </Card>
  );
};
